import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectedSommelierService } from '../../services/selected-sommelier.service';
import { APP_ICONS } from '../../icons/app-icons';

@Component({
  selector: 'app-metro-payment-result',
  templateUrl: './metro-payment-result.component.html',
  standalone:false
})
export class MetroPaymentResultComponent  implements OnInit{
 status: string;
  message: string;
  orderId?: string;
  paymentTransactionId?: string;
  redirectAfter?:number;
  bankInfo?: { account: string; alias: string; cbu: string };

  clipboardIcon= APP_ICONS.clipboard;

  constructor(private route: ActivatedRoute,private router: Router, private selectedSommelierService: SelectedSommelierService) {

  }


ngOnInit() {
  this.route.queryParams.subscribe(params => {
    this.status = params['status'] || 'unknown';
    this.message = params['message'] || 'No se pudo determinar el estado del pago.';
    this.orderId = params['orderId'];
    this.paymentTransactionId = params['paymentTransactionId'];
    this.redirectAfter = +params['redirectAfter'] || 0;

    if (this.status === 'transfer') {
      this.bankInfo = {
        account: params['account'] || '',
        alias: params['alias'] || '',
        cbu: params['cbu'] || ''
      };
    }

    if (this.redirectAfter) {
      setTimeout(() => this.selectedSommelierService.navigate(['catalog']), this.redirectAfter);
    }
  });
}


  goToHome() {
    this.selectedSommelierService.navigate(['catalog']);
  }

  copyToClipboard(text: string) {
  if (!text) return;
  navigator.clipboard.writeText(text).then(() => {
    // Podés mostrar un toast o mensaje de éxito
  }).catch(err => {
    console.error('Error al copiar:', err);
  });
}

}
